import { useTranslation } from 'react-i18next';

import Warning from '@/assets/icons/warning.svg?component';
import { Alert } from '@/components/atoms/Alert';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import type { WizardValidationError } from '../../operateWizardHelpers';

import styles from '../../operateModals.module.scss';

interface ValidationBannerProps {
    errors: WizardValidationError[];
}

export function ValidationBanner(props: ValidationBannerProps) {
    const { errors } = props;
    const { t } = useTranslation('fishGroups');

    // Dedupe by code: an operator sees one entry per kind of issue. The
    // detailed payload (which destination / which source) is conveyed by
    // the per-field UI in a future iteration; here we just summarise so the
    // banner stays readable.
    const seen = new Set<string>();
    const uniqueCodes: string[] = [];
    for (const error of errors) {
        if (!seen.has(error.code)) {
            seen.add(error.code);
            uniqueCodes.push(error.code);
        }
    }

    return (
        <Alert
            tone="danger"
            size="small"
            icon={<SvgIcon icon={Warning} size="small" color="currentColor" />}
            title={t('actions.operate.destinations.errors.heading')}>
            <ul className={styles.errorList}>
                {uniqueCodes.map((code) => (
                    <li key={code}>{t(`actions.operate.destinations.errors.${code}`)}</li>
                ))}
            </ul>
        </Alert>
    );
}
